import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatTooltipTruncateModule } from '@y42/core/mat-tooltip-truncate';
import { IntercomTargetModule } from '@y42/intercom';
import { OpenInAssetSidebarButtonModule } from '../../asset-sidebar';
import { EntryGroupCellRendererComponent } from './entry-group-cell-renderer.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    FontAwesomeModule,
    MatIconModule,
    MatTooltipModule,
    MatTooltipTruncateModule,
    MatCheckboxModule,
    IntercomTargetModule,
    OpenInAssetSidebarButtonModule,
  ],
  declarations: [EntryGroupCellRendererComponent],
  exports: [EntryGroupCellRendererComponent],
})
export class EntryGroupCellRendererModule {}
